import { Toast } from 'antd-mobile'
import { ensureLoggedIn } from '../../../common/loginGate'
import { getVerifiedToken } from '../../../common/h5Session'
import { get } from 'lodash'
import React, { Component } from 'react'
import styled from 'styled-components'
import _client from '../../../common/ApolloClient'
import { getPatientIdFromUrl, getQueryParams } from '../../../utils'
import { getBlogGiftInfo, isShowSendGift } from '../actions/queries'

//无选择:HELP_NOTHING   有帮助:HELP_FULNESS   无帮助:HELP_LESS
const HELP_NOTHING = 'HELP_NOTHING' //无选择
const HELP_FULNESS = 'HELP_FULNESS' //有帮助
const HELP_LESS = 'HELP_LESS' //无帮助

const postMessage = (msg) => {
  const stringify = JSON.stringify(msg)
  console.log('hhh1', stringify)
  window.postMessage(stringify, '*')
}

export default class DoesItHelpComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showSendGift: false,
      blog: null,
      bHelp: get(
        props,
        'articleHelpState.articleHelpState.helpState',
        HELP_NOTHING
      ),
      helpFulness:
        get(props, 'articleHelpState.articleHelpState.helpState', '') ===
        HELP_FULNESS
          ? true
          : false,
      helpLess:
        get(props, 'articleHelpState.articleHelpState.helpState', '') ===
        HELP_LESS
          ? true
          : false,
    }
  }

  clickHelp(key, value) {
    // 先确认已登录再动界面：否则会先高亮、请求被拒后回退、最后才弹登录框
    ensureLoggedIn().then(() => this.applyHelp(key, value), () => {})
  }

  applyHelp(key, value) {
    const { helpFulness, helpLess } = this.state
    if (key === HELP_FULNESS) {
      this.setState({
        bHelp: key,
        helpFulness: !value,
        helpLess: helpLess ? value : helpLess,
      })
    } else if (key === HELP_LESS) {
      this.setState({
        bHelp: key,
        helpFulness: helpFulness ? value : helpFulness,
        helpLess: !value,
      })
    }
    if (value) key = HELP_NOTHING // 取消投票
    this.setHelpData({ helpState: key })
  }

  setHelpData({ helpState }) {
    const mutate = this.props.updateArticleHelpState
    const articleId = get(this.props, 'match.params.knowledgeId')
    const patientId = getPatientIdFromUrl(this.props)
    const variables = {
      articleId,
      patientId,
      helpState,
    }
    mutate({
      variables,
    })
      .then((res) => {
        const { helpFulness, helpLess } = this.state
        if (helpFulness || helpLess)
          Toast.info('感谢您的反馈，“共同照护”会继续努力提供更多优质内容。', 1)
      })
      .catch((e) => {
        Toast.info('反馈失败', 1)
      })
  }

  onGiftSuccess = (e) => {
    // alert(JSON.stringify(event));
    setTimeout(async (e) => {
      const rst = await _client.query({
        query: getBlogGiftInfo,
        variables: {
          blogId: get(this.props, 'match.params.knowledgeId'),
          systemType: get(this.props, 'match.params.systemType', 'BG'),
        },
        fetchPolicy: 'network-only',
      })
      this.setState({
        blog: get(rst, 'data.blogs.0'),
      })
    }, 1000)
  }

  componentDidMount() {
    console.log('this.props11', this.props)

    window.addEventListener(
      'event_send_gift_success',
      this.onGiftSuccess,
      false
    )
    const patientId = getPatientIdFromUrl(this.props)

    // 未登录不查：这是按患者维度的互动类查询，查了会被拒并触发登录框
    if (!getVerifiedToken()) return

    _client
      .query({
        query: isShowSendGift,
        variables: {
          patientId,
        },
        fetchPolicy: 'network-only',
      })
      .then((e) => {
        let rstS = get(e, 'data.isShowSendGift.showSendGift')
        const params = getQueryParams(this.props)

        this.setState({
          showSendGift: rstS && params && params.gift,
        })
      })
  }

  async toSendGift() {
    const knowledgeId = get(this.props, 'match.params.knowledgeId')
    const patientId = getPatientIdFromUrl(this.props)
    postMessage({ _id: knowledgeId, patientId, type: 'send_gift_article' })
  }
  getBlogInfo = (e) => {
    if (this.state.blog) {
      return this.state.blog
    }
    return get(this.props, 'blogs.blogs[0]', {})
  }

  render() {
    let { helpFulness, helpLess } = this.state
    const { articleSource, whoSendGiftCount, giftCount } =
      this.getBlogInfo() || {}

    return (
      <RootView>
        {!this.state.showSendGift && <TopLine />}

        {!this.state.showSendGift && (
          <RootView>
            <TitleText>对于本篇内容，您觉得有用的话鼓个掌</TitleText>
            <RowView>
              <ButtonView
                selected={helpFulness}
                onClick={() => this.clickHelp(HELP_FULNESS, helpFulness)}
              >
                <IconImage
                  resizeMode="contain"
                  src={require('./images/icon_clap_down_' +
                    (helpFulness ? 'white' : 'dark') +
                    '.png')}
                />
                <TextView selected={helpFulness}>无帮助</TextView>
              </ButtonView>
              <ButtonView
                selected={helpLess}
                onClick={() => this.clickHelp(HELP_LESS, helpLess)}
              >
                <IconImage
                  resizeMode="contain"
                  src={require('./images/icon_clap_up_' +
                    (helpLess ? 'white' : 'dark') +
                    '.png')}
                />
                <TextView selected={helpLess}>有帮助</TextView>
              </ButtonView>
            </RowView>
          </RootView>
        )}

        {this.state.showSendGift && <TopLine2 />}

        {this.state.showSendGift && (
          <RootView>
            <TitleText>点燃“原创之火”，用行动支持作者</TitleText>
            <ButtonView2 onClick={() => this.toSendGift()}>
              <TextView selected>打赏作者</TextView>
            </ButtonView2>
            <RowView>
              <BottomText>已有</BottomText>
              <BottomText2>{` ${whoSendGiftCount} `}</BottomText2>
              <BottomText>人用心动支持作者</BottomText>
            </RowView>
          </RootView>
        )}

        <BottomLine />
        <div>
          <BottomText>
            *文章涉及内容仅限学习参考，不可作为诊断标准
            {articleSource === 'THIRD_REPRINTED'
              ? ''
              : '\n*未经正式授权严禁转载本文，侵权必究'}
          </BottomText>
        </div>
      </RootView>
    )
  }
}

const RootView = styled.div`
  flex-direction: column;
  display: flex;
  align-items: center;
`

const TopLine = styled.div`
  width: 100%;
  height: 8px;
  padding: 0 15px 0 15px;
  background-size: contain
  background-image:url(${require('./images/line.png')});
`

const TopLine2 = styled.div`
  width: 100%;
  height: 8px;
  padding: 0 15px 0 15px;
  background-size: contain
  background-image:url(${require('./images/ic_divider_1.png')});
`

const TitleText = styled.div`
  width: 272px;
  height: 100%;
  font-size: 16px;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  line-height: 30px;
  margin-top: 17px;
  line-height: inherit;
`

const RowView = styled.div`
  flex-direction: row;
  display: flex;
`

const ButtonView2 = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 123px;
  height: 45px;
  border-radius: 22px;
  margin: 16px;
  background: #ff6f43;
`

const ButtonView = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 123px;
  height: 45px;
  border-radius: 22px;
  margin: 16px;
  &:active {
    background: #ddd;
  }
  ${(props) =>
    props.selected
      ? 'background: rgba(38, 197, 171, 1);'
      : 'border: 1px solid rgba(153, 153, 153, 1);'}
`

const IconImage = styled.img`
  width: 19px;
  height: 19px;
`

const TextView = styled.div`
  height: 25px;
  font-size: 18px;
  font-weight: 500;
  color: ${(props) =>
    props.selected ? 'rgba(255, 255, 255, 1)' : 'rgba(153, 153, 153, 1)'};
  line-height: 25px;
  margin-left: 5px;
`

const BottomLine = styled.div`
  width: 363px;
  height: 1px;
  background: rgba(245, 246, 248, 1);
  margin: 4px 0 12px 0;
`

const BottomText2 = styled.div`
  height: 21px;
  font-size: 14px;
  font-weight: 400;
  color: #ff6f43;
  line-height: 21px;
`

const BottomText = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 21px;
`



// WEBPACK FOOTER //
// ./src/modules/knowledge/components/doesItHelp.js